var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":_vm.loadImg,"alt":""}}),_c('p',[_vm._v("数据加载中...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }